import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { ArticleCard } from "@/components/feature/NewsCard";
import { usePageMeta, JsonLd } from "@/hooks/useSeo";
import { articles, columns, columnMap, type ColumnSlug } from "@/mocks/news";

export default function ColumnPage() {
  const { slug } = useParams<{ slug: ColumnSlug }>();
  const column = columnMap[slug] ?? columnMap.star;

  const list = useMemo(
    () => articles.filter((a) => a.column === column.slug),
    [column.slug],
  );

  const title = `${column.name} - 98爆料 娱乐八卦 明星动态`;
  const description = `98爆料${column.name}栏目：${column.desc}每日更新${column.name}瓜料，吃瓜群众聚集地。`;
  usePageMeta({ title, description });

  const jsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: `98爆料${column.name}`,
      description,
      url: `https://bzkrsm.top/column/${column.slug}`,
      isPartOf: { "@type": "WebSite", name: "98爆料", url: "https://bzkrsm.top/" },
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://bzkrsm.top/" },
          { "@type": "ListItem", position: 2, name: column.name },
        ],
      },
    }),
    [column, description],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Header />

      <main>
        {/* 面包屑 + 页头 */}
        <div className="mx-auto max-w-7xl px-4 pt-5 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="font-medium text-foreground-800">{column.name}</span>
          </nav>
        </div>

        <section
          className="relative mt-4 overflow-hidden"
          style={{ backgroundColor: column.accent }}
        >
          <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
            <span className="flex w-fit items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-bold text-background-50">
              <i className={column.icon}></i>
              98爆料 · {column.name}
            </span>
            <h1 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-4xl">
              {column.name}
            </h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
              {column.desc}
            </p>
          </div>
        </section>

        {/* 栏目 tab */}
        <div className="mx-auto max-w-7xl px-4 py-6 md:px-6">
          <div className="flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-100 p-1">
            {columns.map((c) => (
              <Link
                key={c.slug}
                to={`/column/${c.slug}`}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  c.slug === column.slug
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-secondary-100"
                }`}
              >
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        {/* 列表 */}
        <div className="mx-auto max-w-7xl px-4 pb-14 md:px-6">
          <div className="flex items-center justify-between">
            <h2 className="font-heading text-lg font-black text-foreground-950">
              最新{column.name}
              <span className="ml-2 text-sm font-medium text-foreground-400">
                共 {list.length} 篇
              </span>
            </h2>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((a, i) => (
              <ArticleCard key={a.id} article={a} column={column} rank={i + 1} />
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}